/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { Button, Col, FormText, Row } from 'reactstrap';
import { Translate, ValidatedField, ValidatedForm, isNumber, translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntities as getPharmacies } from 'app/entities/pharmacy/pharmacy.reducer';
import { getEntities as getHospitals } from 'app/entities/hospital/hospital.reducer';
import { createEntity, getEntity, reset, updateEntity } from './pharmacy-hospital-association.reducer';

export const PharmacyHospitalAssociationUpdate = () => {
  const dispatch = useAppDispatch();

  const navigate = useNavigate();

  const { id } = useParams<'id'>();
  const isNew = id === undefined;

  const pharmacies = useAppSelector(state => state.pharmacy.entities);
  const hospitals = useAppSelector(state => state.hospital.entities);
  const pharmacyHospitalAssociationEntity = useAppSelector(state => state.pharmacyHospitalAssociation.entity);
  const loading = useAppSelector(state => state.pharmacyHospitalAssociation.loading);
  const updating = useAppSelector(state => state.pharmacyHospitalAssociation.updating);
  const updateSuccess = useAppSelector(state => state.pharmacyHospitalAssociation.updateSuccess);

  const handleClose = () => {
    navigate(`/pharmacy-hospital-association${location.search}`);
  };

  useEffect(() => {
    if (isNew) {
      dispatch(reset());
    } else {
      dispatch(getEntity(id));
    }

    dispatch(getPharmacies({}));
    dispatch(getHospitals({}));
  }, []);

  useEffect(() => {
    if (updateSuccess) {
      handleClose();
    }
  }, [updateSuccess]);

  const saveEntity = values => {
    if (values.associatedDate !== undefined && typeof values.associatedDate !== 'number') {
      values.associatedDate = Number(values.associatedDate);
    }
    if (values.leavingDate !== undefined && typeof values.leavingDate !== 'number') {
      values.leavingDate = Number(values.leavingDate);
    }
    if (values.timestampentry !== undefined && typeof values.timestampentry !== 'number') {
      values.timestampentry = Number(values.timestampentry);
    }
    if (values.microSec !== undefined && typeof values.microSec !== 'number') {
      values.microSec = Number(values.microSec);
    }
    if (values.lastupdated !== undefined && typeof values.lastupdated !== 'number') {
      values.lastupdated = Number(values.lastupdated);
    }
    if (values.cursor !== undefined && typeof values.cursor !== 'number') {
      values.cursor = Number(values.cursor);
    }
    if (values.createdDtm !== undefined && typeof values.createdDtm !== 'number') {
      values.createdDtm = Number(values.createdDtm);
    }

    const entity = {
      ...pharmacyHospitalAssociationEntity,
      ...values,
      pharmacy: pharmacies.find(it => it.id.toString() === values.pharmacy?.toString()),
      hospital: hospitals.find(it => it.id.toString() === values.hospital?.toString()),
    };

    if (isNew) {
      dispatch(createEntity(entity));
    } else {
      dispatch(updateEntity(entity));
    }
  };

  const defaultValues = () =>
    isNew
      ? {}
      : {
          ...pharmacyHospitalAssociationEntity,
          pharmacy: pharmacyHospitalAssociationEntity?.pharmacy?.id,
          hospital: pharmacyHospitalAssociationEntity?.hospital?.id,
        };

  return (
    <div>
      <Row className="justify-content-center">
        <Col md="8">
          <h2
            id="tinyMedicRestApp.pharmacyHospitalAssociation.home.createOrEditLabel"
            data-cy="PharmacyHospitalAssociationCreateUpdateHeading"
          >
            <Translate contentKey="tinyMedicRestApp.pharmacyHospitalAssociation.home.createOrEditLabel">
              Create or edit a PharmacyHospitalAssociation
            </Translate>
          </h2>
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col md="8">
          {loading ? (
            <p>Loading...</p>
          ) : (
            <ValidatedForm defaultValues={defaultValues()} onSubmit={saveEntity}>
              {!isNew ? (
                <ValidatedField
                  name="id"
                  required
                  readOnly
                  id="pharmacy-hospital-association-id"
                  label={translate('tinyMedicRestApp.pharmacyHospitalAssociation.id')}
                  validate={{ required: true }}
                />
              ) : null}
              <ValidatedField
                label={translate('tinyMedicRestApp.pharmacyHospitalAssociation.associatedDate')}
                id="pharmacy-hospital-association-associatedDate"
                name="associatedDate"
                data-cy="associatedDate"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.pharmacyHospitalAssociation.leavingDate')}
                id="pharmacy-hospital-association-leavingDate"
                name="leavingDate"
                data-cy="leavingDate"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.pharmacyHospitalAssociation.timestampentry')}
                id="pharmacy-hospital-association-timestampentry"
                name="timestampentry"
                data-cy="timestampentry"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.pharmacyHospitalAssociation.microSec')}
                id="pharmacy-hospital-association-microSec"
                name="microSec"
                data-cy="microSec"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.pharmacyHospitalAssociation.lastupdated')}
                id="pharmacy-hospital-association-lastupdated"
                name="lastupdated"
                data-cy="lastupdated"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.pharmacyHospitalAssociation.active')}
                id="pharmacy-hospital-association-active"
                name="active"
                data-cy="active"
                check
                type="checkbox"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.pharmacyHospitalAssociation.cursor')}
                id="pharmacy-hospital-association-cursor"
                name="cursor"
                data-cy="cursor"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.pharmacyHospitalAssociation.openingTime')}
                id="pharmacy-hospital-association-openingTime"
                name="openingTime"
                data-cy="openingTime"
                type="text"
                validate={{
                  maxLength: { value: 100, message: translate('entity.validation.maxlength', { max: 100 }) },
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.pharmacyHospitalAssociation.closeTime')}
                id="pharmacy-hospital-association-closeTime"
                name="closeTime"
                data-cy="closeTime"
                type="text"
                validate={{
                  maxLength: { value: 100, message: translate('entity.validation.maxlength', { max: 100 }) },
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.pharmacyHospitalAssociation.internal')}
                id="pharmacy-hospital-association-internal"
                name="internal"
                data-cy="internal"
                check
                type="checkbox"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.pharmacyHospitalAssociation.createdDtm')}
                id="pharmacy-hospital-association-createdDtm"
                name="createdDtm"
                data-cy="createdDtm"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.pharmacyHospitalAssociation.createdBy')}
                id="pharmacy-hospital-association-createdBy"
                name="createdBy"
                data-cy="createdBy"
                type="text"
                validate={{
                  maxLength: { value: 100, message: translate('entity.validation.maxlength', { max: 100 }) },
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.pharmacyHospitalAssociation.modifiedBy')}
                id="pharmacy-hospital-association-modifiedBy"
                name="modifiedBy"
                data-cy="modifiedBy"
                type="text"
                validate={{
                  maxLength: { value: 100, message: translate('entity.validation.maxlength', { max: 100 }) },
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.pharmacyHospitalAssociation.leftAssociation')}
                id="pharmacy-hospital-association-leftAssociation"
                name="leftAssociation"
                data-cy="leftAssociation"
                check
                type="checkbox"
              />
              <ValidatedField
                id="pharmacy-hospital-association-pharmacy"
                name="pharmacy"
                data-cy="pharmacy"
                label={translate('tinyMedicRestApp.pharmacyHospitalAssociation.pharmacy')}
                type="select"
                required
              >
                <option value="" key="0" />
                {pharmacies
                  ? pharmacies.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <FormText>
                <Translate contentKey="entity.validation.required">This field is required.</Translate>
              </FormText>
              <ValidatedField
                id="pharmacy-hospital-association-hospital"
                name="hospital"
                data-cy="hospital"
                label={translate('tinyMedicRestApp.pharmacyHospitalAssociation.hospital')}
                type="select"
                required
              >
                <option value="" key="0" />
                {hospitals
                  ? hospitals.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <FormText>
                <Translate contentKey="entity.validation.required">This field is required.</Translate>
              </FormText>
              <Button
                tag={Link}
                id="cancel-save"
                data-cy="entityCreateCancelButton"
                to="/pharmacy-hospital-association"
                replace
                color="info"
              >
                <FontAwesomeIcon icon="arrow-left" />
                &nbsp;
                <span className="d-none d-md-inline">
                  <Translate contentKey="entity.action.back">Back</Translate>
                </span>
              </Button>
              &nbsp;
              <Button color="primary" id="save-entity" data-cy="entityCreateSaveButton" type="submit" disabled={updating}>
                <FontAwesomeIcon icon="save" />
                &nbsp;
                <Translate contentKey="entity.action.save">Save</Translate>
              </Button>
            </ValidatedForm>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default PharmacyHospitalAssociationUpdate;
